import { StyleSheet } from "aphrodite";

export default StyleSheet.create({ 
    button: {
        padding: "6px 15px",
        borderRadius: "0px",
    }
 });